import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Testimonials from "../views/Testimonials.vue";
import ContactUs from "../views/ContactUs.vue";
import CaseStudiesPage from "../views/CaseStudiesPage.vue";
import CaseStudyDetail from "../views/CaseStudyDetail.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/testimonials",
        name: "testimonials",
        component: Testimonials,
    },
    {
        path: "/contact",
        name: "contact",
        component: ContactUs,
    },
    {
        path: "/case-studies",
        name: "caseStudies",
        component: CaseStudiesPage,
    },
    {
        path: '/case-studies/:slug',
        name: 'caseStudy',
        component: CaseStudyDetail
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        // Always scroll to top on navigation
        return { top: 0, behavior: 'instant' }
    }
});

export default router;
